import {useEffect, useState} from "react";
import axios from "axios";
import AttributeCard from "../../Cards/AttributeCard";
import {useNewProduct} from "../../../../store/contexts/NewProductContext";

const AttributesTab = () => {
    const {product} = useNewProduct();
    const [categoryAttributes, setCategoryAttributes] = useState([]);

    useEffect(() => {
        if (product?.category_id) {
            axios.get(`/categories/${product.category_id}/attributes`).then(response => {
                setCategoryAttributes(response.data.attributes)
            })
        }

    }, [product.category_id])

    return (
        <>
            {
                categoryAttributes.map((attribute, index) => (
                    <AttributeCard key={index} attribute={attribute} index={index} cat={categoryAttributes}/>
                ))
            }
        </>
    )
}

export default AttributesTab;